import type React from 'react';
import { createElement } from 'react';
import {
	DocumentsIcon,
	GraftsIcon,
	LogOutIcon,
	ManagePatientsIcon,
	ManageUsersIcon,
	MyProfileIcon,
	SupportIcon,
	UtilitiesIcon,
} from '@/assets/icons';
import DenialSupportIcon from '@/assets/icons/DenialSupportIcon';
import WarningIcon from '@/assets/icons/WarningIcon';

export interface ProfileMenuItem {
	title: string;
	icon: React.ReactNode;
	href?: string;
	submenu?: ProfileMenuItem[];
	permissions?: string[];
}

export const profileMenuItems: ProfileMenuItem[] = [
	{
		title: 'Utilities',
		icon: createElement(UtilitiesIcon, { width: 18, height: 18 }),
		permissions: ['GraftsToAssign:Visualize', 'ConfirmedGrafts:Visualize'],
		submenu: [
			{
				title: 'Grafts to Assign',
				icon: createElement(GraftsIcon, { width: 16, height: 16 }),
				href: '/grafts-assign',
				permissions: ['GraftsToAssign:Visualize'],
			},
			{
				title: 'Confirmed Grafts',
				icon: createElement(GraftsIcon, { width: 16, height: 16 }),
				href: '/grafts-confirmed',
				permissions: ['ConfirmedGrafts:Visualize'],
			},
		],
	},
	{
		title: 'Documents',
		icon: createElement(DocumentsIcon, { width: 18, height: 18 }),
		href: '/documents',
		permissions: ['Documents:Visualize'],
	},
	{
		title: 'Manage Patients',
		icon: createElement(ManagePatientsIcon, { width: 18, height: 18 }),
		href: '/manage-patients',
		permissions: ['Patients:Visualize'],
	},
	{
		title: 'Manage Users & Roles',
		icon: createElement(ManageUsersIcon, { width: 18, height: 18 }),
		href: '/manage-users',
		permissions: ['UsersRoles:Visualize'],
	},
	{
		title: 'My Profile',
		icon: createElement(MyProfileIcon, { width: 18, height: 18 }),
		href: '/profile',
		permissions: ['UsersRoles:Profile'],
	},
	{
		title: 'APP Crash Logs',
		icon: createElement(WarningIcon, { width: 18, height: 18 }),
		href: '/app-crash-logs',
		permissions: ['APPCrashLogs:Visualize'],
	},
	{
		title: 'Support',
		icon: createElement(SupportIcon, { width: 18, height: 18 }),
		href: '/support',
		permissions: ['SupportTickets:Visualize'],
	},
	{
		title: 'Denial Support',
		icon: createElement(DenialSupportIcon, { width: 18, height: 18 }),
		href: '/denial-support',
		permissions: ['DenialSupport:Visualize'],
	},
	{
		title: 'Audit',
		icon: createElement(DocumentsIcon, { width: 18, height: 18 }),
		href: '/audit',
		permissions: ['Audit:Visualize'],
	},
	{
		title: 'Log Out',
		icon: createElement(LogOutIcon, { width: 18, height: 18 }),
		href: '/login?logout=true',
	},
];
